import { useState } from "react";
import { useNavigate } from "react-router-dom";
import FormButton from "../../../Components/Buttons/FormButton";
import Table, { Column } from "../../../Components/Tables/Table";
import {
  checkInDetailsReturnPutawayData,
  PutawayLocationDataList,
} from "../../../Data/testData";
import { generateRandom10DigitNumber } from "../../../Utility/Utility";
import { ReturnReceiveItem } from "../Return/Receive/ReturnReceiveItem.type";
import GetSvgIcon from "../../../assets/images/svgList";
import Breadcrumb from "../../../Shared/BreadCrumb/Breadcrumb";
import useMenuStore from "../../../store/menu/useMenuStore";


export default function AddPutaway() {
  const [quantity, setQuantity] = useState<String>("");
  const [trackingNo, setTrackingNo] = useState(0);
  const [unloadSuccessMsg, setUnloadSuccessMsg] = useState("");
  const [receiveItemPutawayList, setReceiveItemPutawayList] = useState<
    ReturnReceiveItem[]
  >([]);

  console.log("receiveItemPutawayList", receiveItemPutawayList);
  const [itemPutaway, setItemPutaway] = useState<ReturnReceiveItem>(
    new ReturnReceiveItem()
  );
  const {items,loading} =useMenuStore();
  const [errMsg, setErrMsg] = useState("");
  const [isShowErr, setShowErr] = useState(false);
  const [successFinalMsg, setSuccessFinalErrMsg] = useState("");
  const [isShowFinal, setShowFinal] = useState(false);
  const [hideErrMsgTimeout, setHideErrMsgTimeout] =
    useState<NodeJS.Timeout | null>(null);

  const [stepLabel, setStepLabel] = useState(
    "Enter Item/UPC # to Start receiving."
  ); // Track label text
  const navigation = useNavigate();
  const handleCancelBtn = () => {
    navigation("/inbound/asn/putaway");
  };
  let numbers = generateRandom10DigitNumber(1000000000, 9999999999);
  const handelItemQuantity = (val: string) => {
    if (val !== "" && receiveItemPutawayList.length === 0) {
      const matchedItem: ReturnReceiveItem | undefined =
        checkInDetailsReturnPutawayData.find((e) => e.ItemCode.text === val);
      if (matchedItem) {
        setTrackingNo(numbers);
        setQuantity(matchedItem.ReceivedQuantity);
        setItemPutaway(matchedItem);
        setReceiveItemPutawayList((prevList) => {
          const itemExists = prevList.some(
            (item) => item.Line === matchedItem?.Line
          );
          if (!itemExists) {
            return [...prevList, matchedItem];
          }
          return prevList;
        });
        setUnloadSuccessMsg("");
        setStepLabel("Enter Quantity"); // Update stepLabel if no error
      } else {
        setShowErr(true);
        setErrMsg("Code not found");
        const timeout = setTimeout(() => {
          setShowErr(false);
          setErrMsg("");
        }, 2000);
        setHideErrMsgTimeout(timeout);
      }
    } else if (val !== "") {
      if (itemPutaway?.ExpectedQty === "0") {
        setItemPutaway((data) => ({ ...data, ExpectedQty: val }));
        setStepLabel("Scan or Enter Bin Location"); // Update stepLabel if no error
      } else {
        setUnloadSuccessMsg(
          "All items have been added to Inventory successfully."
        );
        setSuccessFinalErrMsg("All items successfully received");
        setShowFinal(true);
        const timeout = setTimeout(() => {
          setShowFinal(false);
          setSuccessFinalErrMsg("");
        }, 2000);
        setHideErrMsgTimeout(timeout);
      }
    } else {
      setQuantity("");
      setTrackingNo(0);
    }
  };

  const columns: Column[] = [
    {
      name: "Line#",
      selector: (row: { Line: string }) => row.Line,
    },
    {
      name: "Items",
      selector: (row: { ItemCode: { imgSrc: string; text: string } }) => (
        <div>
          {row.ItemCode.imgSrc && (
            <img
              src={require(`../../../assets/images/${row.ItemCode.imgSrc}`)}
              alt={row.ItemCode.text}
              style={{ width: "20px", marginRight: "8px" }}
            />
          )}
          {row.ItemCode.text}
        </div>
      ),
    },
    {
      name: "UOM",
      selector: (row: { UOM: string }) => row.UOM,
    },
    {
      name: "Qty to received",
      selector: (row: { ReceivedQuantity: string }) => row.ReceivedQuantity,
    },
  ];

  const columnForSuggestedLocation: Column[] = [
    {
      name: "Current Location",
      selector: (row: { cLocation: string }) => row.cLocation,
    },
    {
      name: "Quantity",
      selector: (row: { qnt: string }) => row.qnt,
    },
    {
      name: "",
      selector: () => null,
    },
  ];

  const handleSaveBtn = () => {
    if (receiveItemPutawayList.length === 0) {
      setShowErr(true);
      setErrMsg("Enter Item/UPC");
      const timeout = setTimeout(() => {
        setShowErr(false);
        setErrMsg("");
      }, 2000);

      setHideErrMsgTimeout(timeout);
    } else if (itemPutaway.ExpectedQty === "0") {
      setShowErr(true);
      setErrMsg("Enter Quantity");
      const timeout = setTimeout(() => {
        setShowErr(false);
        setErrMsg("");
      }, 2000);

      setHideErrMsgTimeout(timeout);
    } else if (unloadSuccessMsg === "") {
      setShowErr(true);
      setErrMsg("Enter Location");
      const timeout = setTimeout(() => {
        setShowErr(false);
        setErrMsg("");
      }, 2000);

      setHideErrMsgTimeout(timeout);
    } else {
      navigation("/inbound/asn/putaway");
    }
  };
  return (
    <div>
      <Breadcrumb navigationData={items} />
      <div className="d-flex flex-column h-100">
        <div className="d-flex justify-content-start mt-3">
          {isShowErr && (
            <div
              className="alert alert-danger text-center position-fixed alert-on-top"
              role="alert"
            >
              {errMsg}
            </div>
          )}
          {isShowFinal && (
            <div
              className="alert alert-danger text-center position-fixed alert-on-top"
              role="alert"
            >
              {successFinalMsg}
            </div>
          )}
          <div className="col">
            <div className="top-tab p-3">
              <div className="">
                ASN: <strong>B5487996</strong>
              </div>
            </div>
          </div>
          <div className="col mx-2">
            <div className="top-tab p-3">
              <div className="">
                Location: <strong>19-Door</strong>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="top-tab p-3">
              <div className="">
                Warehouse: <strong>Area-12</strong>
              </div>
            </div>
          </div>
          <div className="col mx-2">
            <div className="top-tab p-3">
              <div className="">
                Tracking#: <strong>3568257444</strong>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between my-3">
          <div className="col d-flex flex-column justify-content-between scanning-area">
            <div className="d-flex align-items-center justify-content-around scanning-area-top">
              {stepLabel}
            </div>

            <div className="bg-white p-4 scanning-area-bottom">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control rounded-start-pill  border border-info border-end-0 p-3 scanner-input"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-lg"
                  placeholder={stepLabel}
                  name="txt_item"
                  onKeyDown={(e) => {
                    if (e.key === "Tab" || e.key === "Enter") {
                      handelItemQuantity((e.target as HTMLInputElement).value);
                      (e.target as HTMLInputElement).value = "";
                    } else if (e.key === "Backspace" || e.key === "Delete") {
                      handelItemQuantity("");
                      setTrackingNo(0);
                    }
                  }}
                />
                <span
                  className="input-group-text rounded-end-pill bg-white border border-info border-start-0 cursor-pointer"
                  id="inputGroup-sizing-lg"
                >
                  {GetSvgIcon.UpcScanner}
                </span>
              </div>
            </div>
            <div className="d-flex justify-content-between mt-2">
              <div className="col me-1">
                <div className="top-tab p-3 d-flex justify-content-between">
                  <div className="">
                    <strong>Quantity:</strong>
                  </div>
                  <div className="">
                    {itemPutaway.ExpectedQty !== "0" &&
                      itemPutaway.ExpectedQty !== "" && (
                        <>{GetSvgIcon.RoundTik}</>
                      )}
                    <strong>{quantity}</strong>
                  </div>
                </div>
              </div>
              <div className="col ms-1">
                <div className="top-tab p-3 d-flex justify-content-between">
                  <div className="">
                    <strong>Item/UPC:</strong>
                  </div>
                  <div className="">
                    <strong>{trackingNo > 0 ? trackingNo : ""}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-8 ms-2">
            <div className="top-tab h-100 p-2">
              {receiveItemPutawayList.length > 0 && (
                <>
                  <div className="table-header d-flex mx-5 fw-bold row px-0 mt-3">
                    <div className="col-3">
                      <label>Items</label>
                    </div>
                    <div className="col-3">
                      <label>UOM</label>
                    </div>
                    <div className="col-3">
                      <label>Received Qty</label>
                    </div>
                    <div className="col-3">
                      <label>Putaway Qty</label>
                    </div>
                  </div>
                  <div className="row d-flex mx-5 mt-3 align-items-center border-bottom pb-3">
                    <div className="col d-flex">
                      {itemPutaway.ItemCode.imgSrc && (
                        <img
                          src={require(`../../../assets/images/${itemPutaway.ItemCode.imgSrc}`)}
                          alt={itemPutaway.ItemCode.text}
                          style={{ width: "40px", marginRight: "8px" }}
                        />
                      )}
                      <div className="name">
                        <label className="fw-bold d-block">Rose Patel</label>
                        {itemPutaway.ItemCode.text}
                      </div>
                    </div>
                    <div className="col-3">
                      <label>{itemPutaway.UOM}</label>
                    </div>
                    <div className="col-3">
                      <label>{itemPutaway.ReceivedQuantity}</label>
                    </div>
                    <div className="col-3">
                      <label>
                        {itemPutaway.ExpectedQty !== "0"
                          ? itemPutaway.ExpectedQty
                          : "-"}
                      </label>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="row d-flex mb-4">
          <div className="col-4">
            {unloadSuccessMsg === "" && (
              <div className="justify-content-between ">
                {receiveItemPutawayList.length > 0 ? (
                  <Table
                    columns={columns}
                    data={receiveItemPutawayList}
                    CheckboxStatus={false}
                  />
                ) : (
                  ""
                )}
              </div>
            )}
            {unloadSuccessMsg !== "" && (
              <>
                <div className="white-body d-flex justify-content-center align-items-center">
                  <div>
                    <div className="mt-5 d-flex justify-content-center">
                      {GetSvgIcon.ScannerSuccessLogo}
                    </div>
                    <div className="col-12 mt-3 mb-5">
                      <strong>{unloadSuccessMsg}</strong>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="col-8 mt-2 ps-0 suggestedLocWrapper px-3">
            {receiveItemPutawayList.length > 0 ? (
              <>
                <p className="fw-bold mb-2">Suggested Location</p>
                <div className="bg-white p-3 rounded-3">
                  <Table
                    columns={columnForSuggestedLocation}
                    data={PutawayLocationDataList}
                    CheckboxStatus={false}
                    customClassName="SuggestedLocation"
                    isStripped={true}
                  ></Table>
                </div>
              </>
            ) : null}
          </div>
        </div>

        <div className="mt-auto bg-white rounded py-3 d-flex justify-content-end">
          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <FormButton
                tabIndex={12}
                className="sph-btn sph-shift me-4"
                handleClick={handleCancelBtn}
              >
                Close
              </FormButton>
              <FormButton
                tabIndex={11}
                className="sph-btn me-4"
                handleClick={handleSaveBtn}
              >
                Submit
              </FormButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
